import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7df358d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-top":"5px","margin-right":"5px"} }
const _hoisted_2 = { class: "flex flex-row justify-content-between w-full align-content-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "4" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Nedecontat")
], -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", {
    colspan: "4",
    style: {"text-decoration":"underline"}
  }, " IN CURS DE DECONTARE ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { colspan: "4" }, "ISTORIC DECONTARI")
], -1))

import { PayoutInfo } from '@/interfaces/PayoutInfo';
import { ref, PropType, watch } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import { MoneyUtils } from '@/utils/MoneyUtils';
import { DateUtils } from '@/utils/DateUtils';
import { DoctorPayoutInfo } from '@/interfaces/DoctorPayoutInfo';
import { useToast } from 'primevue/usetoast';
import { useRoute, useRouter } from 'vue-router';
import { useConfirm } from 'primevue/useconfirm';
import PayoutService from '@/services/PayoutService';


export default /*#__PURE__*/_defineComponent({
  __name: 'PayoutHistoryList',
  props: {
  payouts: {
    type: Array as PropType<PayoutInfo[]>,
    default: () => []
  },
  payoutsim: {
    type: Array as PropType<DoctorPayoutInfo[]>,
    default: () => []
  },
  payoutsongoing: {
    type: Array as PropType<PayoutInfo[]>,
    default: () => []
  }
},
  setup(__props) {

const props = __props;

const route = useRoute();
const confirm = useConfirm();
const router = useRouter();
const toast = useToast();
const doctorId = route.params.id as string;

const filteredPayouts = ref<PayoutInfo[]>([...props.payouts]);
const ongoingPayouts = ref<PayoutInfo[]>([...props.payoutsongoing]);
const payoutSimulaton = ref<DoctorPayoutInfo[]>([...props.payoutsim]);

const safeDisplay = (value: string): string => value || '';
const hide = (text: string) => {
  return '';
};

const onSelectedRow = (event: any) => {
  if (event.data.status == 0) {
    //alert('Acest utilizator a fost sters');
  } else {
    const selectedDoctorId = event.data.id;
    //router.push({ name: 'payout-details', params: { id: selectedDoctorId } });
  }
};

watch(
  () => props.payouts,
  (newValue) => {
    filteredPayouts.value = [...newValue];
  },
  { immediate: true }
);

watch(
  () => props.payoutsongoing,
  (newValue) => {
    if (Array.isArray(newValue)) {
      ongoingPayouts.value = [...newValue];
    } else {
      ongoingPayouts.value = [newValue];
    }
  },
  { immediate: true }
);

watch(
  () => props.payoutsim,
  (newValue) => {
    payoutSimulaton.value = [...newValue];
  },
  { immediate: true }
);

const callPayout = () => {
  confirm.require({
    message: 'Suneti sigur ca doriti sa initiati o decontare?',
    header: 'Confirmare',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Da',
    rejectLabel: 'Nu',
    accept: async () => {
      try {
        const savedPayout =
          await PayoutService.triggerPayoutForDoctor(doctorId);
        if (savedPayout && savedPayout.id) {
          showSuccess('Procesul de decontare manuala a fost initiat');
          setTimeout(() => {
            location.reload();
          }, 1000);
        } else {
          showError('Nu s-a putut initia procesul de decontare manuala');
        }
      } catch {
        showError('Nu s-a putut initia procesul de decontare manuala');
      }
    }
  });
};

const showError = (message: string): void => {
  toast.add({
    severity: 'error',
    summary: 'A aparut o eroare!',
    detail: message,
    life: 3000
  });
};

const showSuccess = (message: string): void => {
  toast.add({
    severity: 'success',
    summary: 'Actiune realizata cu succes!',
    detail: message,
    life: 3000
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DataTable), {
      value: payoutSimulaton.value,
      size: "small",
      dataKey: "id"
    }, {
      header: _withCtx(() => [
        _createElementVNode("tr", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(Button), {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (callPayout())),
            severity: "success",
            outlined: "",
            class: "p-button-sm text-sm",
            icon: "pi pi-dollar text-xs",
            label: "Decontare"
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          style: {"width":"28%"},
          header: "Data decontare"
        }, {
          body: _withCtx(({ data }) => [
            (data?.nextPayoutDate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(DateUtils).format(data?.nextPayoutDate)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString('La atingere venit consultatii: ' +
              _unref(MoneyUtils).format(data?.nextPayoutAmount, 'RON')), 1))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          style: {"width":"18%"},
          header: "Numar consultatii"
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(data?.numberOfConsultations), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          style: {"width":"18%"},
          header: "Total consultatii"
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(data?.currency
                ? _unref(MoneyUtils).format(data?.totalAmount, data?.currency)
                : ''), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          style: {"width":"18%"},
          header: "Beneficiu medic"
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(data?.currency
                ? _unref(MoneyUtils).format(data?.doctorAmount, data?.currency)
                : ''), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          style: {"width":"18%"},
          header: "Comision DoctorApp"
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(data?.currency
                ? _unref(MoneyUtils).format(data?.platformAmount, data?.currency)
                : ''), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"]),
    (__props.payoutsongoing)
      ? (_openBlock(), _createBlock(_unref(DataTable), {
          key: 0,
          value: ongoingPayouts.value,
          size: "small",
          dataKey: "id"
        }, {
          header: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Column), {
              style: {"width":"28%"},
              header: "Data decontare"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(_unref(DateUtils).format(_unref(DateUtils).nextDayOf(data.runDate))), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              style: {"width":"18%"},
              header: "Numar consultatii"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(data?.numberOfConsultations), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              style: {"width":"18%"},
              header: "Total consultatii"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(_unref(MoneyUtils).format(data.totalAmount, data.currency)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              style: {"width":"18%"},
              header: "Beneficiu medic"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(_unref(MoneyUtils).format(data.payoutAmount, data.currency)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              style: {"width":"18%"},
              header: "Comision DoctorApp"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(_unref(MoneyUtils).format(data.commissionAmount, data.currency)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(DataTable), {
      value: filteredPayouts.value,
      size: "small",
      dataKey: "id"
    }, {
      header: _withCtx(() => [
        _hoisted_7
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          style: {"width":"28%"},
          header: "Data decontare"
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(DateUtils).format(data.runDate)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          style: {"width":"18%"},
          header: "Numar consultatii"
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(data?.numberOfConsultations), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          style: {"width":"18%"},
          header: "Total consultatii"
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(MoneyUtils).format(data.totalAmount, data.currency)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          style: {"width":"18%"},
          header: "Beneficiu medic"
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(MoneyUtils).format(data.payoutAmount, data.currency)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          style: {"width":"18%"},
          header: "Comision DoctorApp"
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(MoneyUtils).format(data.commissionAmount, data.currency)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})